<template>
  <div
    class="item"
    :style="{'background-image':`url(${article.PIC || defaultPic})`}"
    v-for="(article, index) in articleList[type].slice(0, mediaClass.portOrLand === 'po' ? 2 : 3)"
    :key="index"
    v-if="articleList[type] && articleList[type].length > 0"
    @click="jumpLink(article.ID, article.ARTICLE_TYPE_ID, article.REDIRECT_LINK)"
  >
    <p class="item-title">{{
      article.TITLE
    }}</p>
  </div>
  <p class="empty" v-else>{{ $t('noContent') }}</p>
</template>

<script lang="ts" setup>
import newsHook from '@/hooks/newsHook';
import mediaClass from "@/hooks/queryMediaClass";
const props = defineProps({
  type: {
    type: String,
  },
});
const { defaultPic, jumpLink } = newsHook();
import { articleList } from "@/hooks/commonArticleHook";
</script>
